<template>
  <Modal 
    :id="'cmp_bookings_booking_add_artist'"
    @cancelled="onCancelClick"  
  >
    <template slot="header">
      {{$t('please_confirm_exchange_rate')}}
    </template>
    <template slot="body">

      
        <TextField
          
          class="m1"
       
          :id="'exchangerate'"
          v-bind="textFieldConfig"
          :value="exchangerate"
          :placeholder="$t('exchangerate')"
          @valuechanged="onTextFieldChange"
        
        >
        </TextField>
        <TextField
          
          class="m1"
       
          :id="'external_ref'"
          v-bind="textFieldConfig"
          :value="external_ref"
          :placeholder="$t('costs_reference_no')"
          @valuechanged="onTextFieldChange"
        
        >
        </TextField>
        <Dropdown
        
          :options="costGroupTV"
          class="group-input m2"
          id="cost_group_id"
          :placeholder="$t('select_costgroup')"
          :selected="costGroupTV.find(e=>e.value==cost_group_id)"
          v-on:selectedChange="(e) => onDropdownChange('cost_group_id',e)"
          box            
          :listHeight="250"
        >
        </Dropdown>
        
        
    </template>
    <template slot="options">
        
        <button class="dt-button s7" @click="onCancelClick" >{{$t('cancel')}}</button>
        <button class="dt-button s7 v1" @click="onOKClicked" >{{$t('OK')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from '../../../../dt-plugins/modal/modal';


import NTable from "../../../../plugins/datatable/datatable";








import ModalContainer from "@dtplugins/modal/modal-container";

import {  closeModalRoute  } from "../../../../dt-plugins/modal/modal.mixin";


import { createNTableConfig } from '../../../../plugins/datatable';

import { createTableHeader } from "../../../../plugins/datatable";



import {
  createTV,
  tv,
} from "../../../../models/text-value.model";


import { MHTTPCL } from '../../../../services/http/http-client';
import { SupplierOrdersService } from '../../services/supplier.order.service';

import { Subject } from "rxjs";
import { waitForAnimation, subscribeSubject } from "@/utility";

export default {
  components: {
    
    Modal,
    NTable,


    ModalContainer,   
    //AdvanceSearch,
   
  },
  mounted:async  function () {
    const modalInitData = await SupplierOrdersService.accountCostsMultiProduct(this.supplier_order_id);
    console.log(modalInitData,":::::::::::::::::")
    this.costGroupList =modalInitData.data.cost_groups;
  },
  data: function () {
    return {

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        immediateValidation: false,
      },
      
     

      list:[],

      costGroupList:[],
      
      exchangerate:'',
      
      external_ref:'',
      

      cost_group_id:'',

    

    };
  },
  mixins: [
    
  ],

  computed: {
  
    costGroupTV:function(){
      return createTV(this.costGroupList,'cost_group_name','cost_group_id')
    },

    supplier_order_id:function(){
      return this.$route.query.supplier_order_id;
    },

  
    
  },
  methods: { 
  
    onOKClicked:async function(){
   
        this.onCancelClick();
    },
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },


    onDropdownChange: async function (key,value) {
      
      this[key]=value.value

    },
    
    onTextFieldChange: function(name, value) {

        console.log(name, value)
        this[name] =value;
    },





  
  },

  // [
  //   {"product_id":"76","order_qty":10,"cost_price":2.1,"foc_qty":10},
  //   {"product_id":"77","order_qty":20,"cost_price":2.1,"foc_qty":20}
  // ]
};
</script>